import axios from 'axios';
import { ADMIN_PDF_REPORTS_ROUTE, API_PATH_PREFIX } from '../../api/backend';
import { CreatePdfReportRequest } from '../../common/model/dto/pdf-report/create-pdf-report-request';
import { UpdatePdfReportRequest } from '../../common/model/dto/pdf-report/update-pdf-report-request';
import { PdfReport } from '../../common/model/dto/pdf-report';
import { Paginated } from '../../common/types';

export const getPdfReports = async (query: string) => {
  const { data } = await axios.get<Paginated<PdfReport>>(
    `${ADMIN_PDF_REPORTS_ROUTE}?${query}`
  );

  return data;
};

export const updatePdfReport = async (
  pdfReportId: string,
  updatePdfReportRequest: UpdatePdfReportRequest
) => {
  return await axios.patch(
    `${ADMIN_PDF_REPORTS_ROUTE}/${pdfReportId}`,
    updatePdfReportRequest
  );
};

export const deletePdfReport = async (pdfReportId: string) => {
  return await axios.delete(`${ADMIN_PDF_REPORTS_ROUTE}/${pdfReportId}`);
};

export const createPdfReport = async (
  userId: string,
  createPdfReportRequest: CreatePdfReportRequest
) => {
  return await axios.post(
    `admin/pdf-reports/users/${userId}`,
    createPdfReportRequest,
    {
      baseURL: `${process.env.REACT_APP_FILE_SERVICE_URL}${API_PATH_PREFIX}`,
    }
  );
};
